import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "naijaman_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch { /* noop */ }
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const lineKey = (id, size) => `${id}__${size || "_"}`;

  const addItem = useCallback((product, size, quantity = 1) => {
    setItems((prev) => {
      const k = lineKey(product.id, size);
      const existing = prev.find((i) => lineKey(i.product_id, i.size) === k);
      if (existing) {
        return prev.map((i) =>
          lineKey(i.product_id, i.size) === k ? { ...i, quantity: Math.min(99, i.quantity + quantity) } : i
        );
      }
      return [...prev, {
        product_id: product.id, name: product.name, price: product.price,
        image: product.image, size: size || null, quantity,
      }];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((product_id, size, quantity) => {
    setItems((prev) =>
      prev.map((i) =>
        i.product_id === product_id && (i.size || null) === (size || null)
          ? { ...i, quantity: Math.max(1, quantity) }
          : i
      )
    );
  }, []);

  const removeItem = useCallback((product_id, size) => {
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && (i.size || null) === (size || null))));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((n, i) => n + i.quantity, 0);
  const subtotal = items.reduce((n, i) => n + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, addItem, updateQty, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};
